import React from 'react';
import './App.css';

function GenericPage() {

  return (
    
      <main className="content">

      </main>

  );
}

export default GenericPage;